import { Star } from "lucide-react";
import AdminList from "@/admin/components/AdminList";

export default function EventList() {
  return (
    <AdminList
      testId="admin-events-list"
      title="Eventos"
      kicker="Gestão de Conteúdo"
      resource="events"
      createTo="/admin/eventos/novo"
      editTo="/admin/eventos"
      columns={[
        {
          key: "name", label: "Evento",
          render: (e) => (
            <div className="flex items-center gap-3">
              {e.cover_image && <img src={e.cover_image} className="w-12 h-12 rounded-lg object-cover border border-[#2a2a2a]" alt="" />}
              <div><div className="text-white font-medium">{e.name}</div><div className="text-[10px] tracking-[0.2em] uppercase text-[#7d7d7d] mt-0.5">{e.slug}</div></div>
            </div>
          ),
        },
        { key: "city", label: "Cidade", render: (e) => `${e.city}${e.state ? " / " + e.state : ""}` },
        { key: "date", label: "Data", render: (e) => e.date ? new Date(e.date + "T12:00:00").toLocaleDateString("pt-BR") : "—" },
        { key: "featured", label: "Destaque", render: (e) => e.featured ? <Star size={13} fill="#C6A762" className="text-[#C6A762]" /> : "—" },
      ]}
    />
  );
}
